<div ngSkipHydration>
<div class="container-fluid mt-3 px-3" style="font-size: 0.85rem;">
  
  <div class="d-flex justify-content-between align-items-center mb-3 border-bottom pb-2">
    <h2 class="h4 m-0 fw-bold text-dark">Listado de Unidades Vehiculares</h2>
    <a class="btn btn-sm btn-primary px-4 fw-bold shadow-sm" routerLink="/unidad/add" routerLinkActive="active" ariaCurrentWhenActive="page">
      🚗 Crear Nueva Unidad
    </a>
  </div>


  <div class="card mb-3 border-0 shadow-sm bg-light">
    <div class="card-body p-2">
      <div class="row g-2">
        <div class="col-md-12">
          <div class="input-group input-group-sm">
            <span class="input-group-text bg-white border-end-0">🔍</span>
            <!-- 💡 CORREGIDO: Añadido name="busquedaUnidad" para dar soporte completo al ngModel -->
            <input type="text" 
                  class="form-control border-start-0 ps-0 text-uppercase" 
                  id="busquedaUnidad" 
                  name="busquedaUnidad"
                  [(ngModel)]="filtroUnidad" 
                  (input)="filtrarUnidades()" 
                  placeholder="Buscar vehículos por placas, submarca, modelo, dueño o AN8...">
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Contenedor responsivo vital para tablas con muchos campos técnicos -->
  <div class="table-responsive shadow-sm rounded border bg-white">
    <table class="table table-hover table-striped m-0 text-nowrap">
      <thead class="table-dark text-center" style="font-size: 0.8rem;">
        <tr>
          <th scope="col" style="width: 60px;">ID</th>
          <!-- ========================================================================= -->
          <!-- REFACTORIZACIÓN CORE: UNIFICACIÓN AL ESTÁNDAR AN8 DEL PROPIETARIO         -->
          <!-- ========================================================================= -->
          <th scope="col" style="width: 120px;">DUEÑO (AN8)</th>
          <th scope="col">MARCA</th>
          <th scope="col">SUBMARCA</th>
          <th scope="col" style="width: 110px;">PLACAS</th>
          <th scope="col" style="width: 90px;">MODELO</th>
          <th scope="col" style="width: 100px;">AÑO FAB.</th>
          <th scope="col">COMBUSTIBLE</th>
          <th scope="col">TIPO SERVICIO</th>
          <th scope="col">NÚMERO VIN</th>
          <th scope="col">NÚMERO MOTOR</th>
          <th scope="col">FECHA ALTA</th>
          <th scope="col">FECHA BAJA</th>
          <th scope="col" style="width: 100px;">ESTATUS</th>
          <th scope="col">COLOR</th>
          <th scope="col">T. CIRCULACIÓN</th>
          <th scope="col" class="text-center" style="width: 90px;">ELIMINAR</th>
          <th scope="col" class="text-center" style="width: 90px;">EDITAR</th>
        </tr>
      </thead>
      <tbody class="align-middle">
        <!-- 💡 SOLUCIÓN: Cambia 'unidades' por 'unidadesFiltradas' para activar tu buscador reactivo -->
          <tr *ngFor="let c of unidadesPaginadas; trackBy: trackById">
          <th scope="row" class="text-center font-monospace bg-light text-secondary">{{ c.id }}</th>
          
          <!-- NAVEGACIÓN RELACIONAL: Acceso seguro al AN8 numérico del sub-objeto customer -->
          <!-- <td class="font-monospace fw-bold text-primary text-center">
            {{ c.customer?.an8 ? c.customer.an8 : 'SIN DUEÑO' }}
          </td> -->

          <!-- REEMPLAZO CORREGIDO (Match estricto con Angular v22) -->
          <td class="font-monospace fw-bold text-primary text-center">
            {{ c.propietario.an8 }}
          </td>
          
          <td class="fw-semibold text-dark">{{ c.marca }}</td>
          <td>{{ c.submarca }}</td>
          <td class="text-uppercase font-monospace text-center fw-bold text-dark bg-light">{{ c.placas }}</td>
          <td class="text-center font-monospace">{{ c.modelo }}</td>
          <td class="text-center font-monospace">{{ c.aniofabricacion }}</td>
          <td>{{ c.tipocombustible }}</td>
          <td>{{ c.tiposervicio }}</td>
          <td class="font-monospace text-secondary">{{ c.numerovin }}</td>
          <td class="font-monospace text-secondary">{{ c.numeromotor }}</td>
          <td class="text-muted" style="font-size: 0.78rem;">{{ c.fechaalta }}</td>
          <td class="text-muted" style="font-size: 0.78rem;">{{ c.fechabaja ? c.fechabaja : '-' }}</td>
          
          <td class="text-center">
            <span class="badge" 
                  [ngClass]="{
                    'bg-success': c.status === 'ACTIVO',
                    'bg-warning text-dark': c.status === 'EN TALLER',
                    'bg-danger': c.status === 'Baja' || c.status === 'INACTIVO'
                  }">
              {{ c.status }}
            </span>
          </td>
          
          <td class="text-center">{{ c.color }}</td>
          <td class="text-center font-monospace">{{ c.tcirculacion }}</td>

          <!-- REHABILITADO: Dispara el borrado enviando la propiedad nativa del vehículo -->
          <td class="text-center"> 
            <button class="btn btn-danger btn-sm p-1 px-2" (click)="deleteUnidad(c.id!)">
              Eliminar
            </button> 
          </td>
          
          <td class="text-center"> 
            <button class="btn btn-info btn-sm text-white p-1 px-2" (click)="editUnidad(c)">
              Actualizar
            </button> 
          </td>
        </tr>

        <!-- Fila amigable por si la base de datos de vehículos está vacía -->
        <tr *ngIf="unidades.length === 0">
          <td colspan="18" class="text-center text-muted py-4">
            No se encontraron registros de vehículos en la base de datos del taller.
          </td>
        </tr>
      </tbody>
    </table>
  </div>

</div>

<!-- 🌟 CONTENEDOR FLOTANTE DE TOASTS EN EL LISTADO -->
<div class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 1080; margin-top: 50px;">
  <div *ngFor="let toast of toastService.toasts" 
       class="toast show shadow border-0 mb-2" 
       [ngClass]="'bg-' + toast.type + '-subtle text-dark'"
       role="alert" aria-live="assertive" aria-atomic="true">
    
    <!-- Encabezado de la Alerta -->
    <div class="toast-header border-0 bg-transparent text-dark d-flex justify-content-between align-items-center">
      <strong class="me-auto d-flex align-items-center gap-2">
        <span *ngIf="toast.type === 'danger'">⚠️</span>
        <span *ngIf="toast.type === 'success'">✅</span>
        {{ toast.title }}
      </strong>
      <button type="button" class="btn-close" (click)="toastService.remove(toast)" aria-label="Close"></button>
    </div>
    
    <!-- Cuerpo de la Alerta -->
    <div class="toast-body pt-0" style="font-size: 0.85rem;">
      {{ toast.text }}
    </div>
  </div>
</div>


<!-- 🎛️ BOTONERA ERGONÓMICA: BOTONES A LA IZQUIERDA Y LEYENDAS A LA DERECHA -->
<div class="d-flex justify-content-between align-items-center mt-3 border-top pt-2">

  <!-- 🧭 BARRA DE PAGINACIÓN INTERACTIVA CON SALTOS EXTREMOS (IZQUIERDA) -->
  <nav aria-label="Navegación de vehículos">
    <ul class="pagination pagination-sm m-0 shadow-sm" style="border-radius: 6px; overflow: hidden; font-size: 0.82rem;">

      <!-- Botón de Salto al Inicio Absoluto (Primera Página) -->
      <li class="page-item" [class.disabled]="paginaActual === 1">
        <button type="button" class="page-link fw-bold text-dark border px-2.5" 
                (click)="cambiarPagina(1)" style="cursor: pointer;" title="Ir a la primera página">
          ⏮️ Primera
        </button>
      </li>

      <!-- Botón de Retroceder Anterior -->
      <li class="page-item" [class.disabled]="paginaActual === 1">
        <button type="button" class="page-link fw-bold text-dark border" (click)="cambiarPagina(paginaActual - 1)" style="cursor: pointer;">
          ◀️ Anterior
        </button>
      </li>

      <!-- Píldora Central Indicadora Estilo ERP Modular -->
      <li class="page-item disabled">
        <span class="page-link bg-light text-dark font-monospace border fw-bold px-3">
          PÁGINA {{ paginaActual }} DE {{ totalPaginas }}
        </span>
      </li>

      <!-- Botón de Avanzar Siguiente -->
      <li class="page-item" [class.disabled]="paginaActual === totalPaginas">
        <button type="button" class="page-link fw-bold text-dark border" (click)="cambiarPagina(paginaActual + 1)" style="cursor: pointer;">
          Siguiente ▶️
        </button>
      </li>

      <!-- Botón de Salto al Final Absoluto (Última Página) -->
      <li class="page-item" [class.disabled]="paginaActual === totalPaginas">
        <button type="button" class="page-link fw-bold text-dark border px-2.5" 
                (click)="cambiarPagina(totalPaginas)" style="cursor: pointer;" title="Ir a la última página">
          Última ⏭️
        </button>
      </li>

    </ul>
  </nav>

  <!-- 📊 RENDIMIENTO DE CONTEO Y LEYENDAS INDEXADAS EN RED (DERECHA) -->
  <span class="text-muted small text-end">
    Mostrando vehículos del <strong>{{ ((paginaActual - 1) * registrosPorPagina) + 1 }}</strong> 
    al <strong>{{ Math.min(paginaActual * registrosPorPagina, unidadesFiltradas.length) }}</strong> 
    de un total de <strong>{{ unidadesFiltradas.length }}</strong> indexados en este taller.
  </span>

</div>


<!-- ========================================================================= -->
<!-- 🚀 CONTENEDOR FLOTANTE RE-RENDEREADO DE TOASTS CORPORATIVOS               -->
<!-- ========================================================================= -->
<div class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 1080; margin-top: 50px;">
  <div *ngFor="let toast of toastService.toasts" 
        class="toast show shadow border-0 mb-2" 
        [ngClass]="'bg-' + toast.type + '-subtle text-dark'"
        role="alert" aria-live="assertive" aria-atomic="true">
    <div class="toast-header border-0 bg-transparent text-dark d-flex justify-content-between align-items-center">
      <strong class="me-auto d-flex align-items-center gap-2">
        <span>{{ toast.type === 'danger' ? '⚠️' : '✅' }}</span>
        {{ toast.title }}
      </strong>
      <button type="button" class="btn-close" (click)="toastService.remove(toast)"></button>
    </div>
    <div class="toast-body pt-0" style="font-size: 0.85rem;">
      {{ toast.text }}
    </div>
  </div>
</div>

</div>

<router-outlet></router-outlet>